import { render, staticRenderFns } from "./view-history-contract.vue?vue&type=template&id=27a695f7&scoped=true&"
import script from "./view-history-contract.vue?vue&type=script&lang=js&"
export * from "./view-history-contract.vue?vue&type=script&lang=js&"
import style0 from "./view-history-contract.vue?vue&type=style&index=0&id=27a695f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a695f7",
  null
  
)

export default component.exports